export const priceDisplay = (price) => {
  return '$' + parseFloat(Math.round(price * 100) / 100).toFixed(2);
}

export const discountedPriceDisplay = (price, discountPercent, discountAmount) => {
  let finalPriceToDisplay = '0';
  let finalPrice = 0;
  if (discountPercent > 0) {
    finalPrice = price - (price * discountPercent / 100);

  }
  else {
    finalPrice = parseFloat(price - discountAmount);
  }
  if (finalPrice < 0)
    finalPrice = 0;

  finalPriceToDisplay = '$' + parseFloat(finalPrice).toFixed(2);
  return finalPriceToDisplay;
}